import angular from 'angular';
import uiRouter from 'angular-ui-router';
import episodevalueComponent from './episodevalue.component';

let episodevalueModule = angular.module('episodevalue', [
  uiRouter
])

.component('episodevalue', episodevalueComponent);

export default episodevalueModule;



// WEBPACK FOOTER //
// ./client/app/common/admin/episodevalue/episodevalue.js